import React, { useEffect } from 'react';
import PaymentDisplay from './PaymentDisplay';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaymentNfcRedirect() {
  useEffect(() => {
    window.location.replace(`${API}/payments/nfc`);
  }, []);

  return <PaymentDisplay />;
}
